import React from 'react'
import TextField from 'material-ui/TextField'
class PrintData extends React.Component {

  render() {
    const { item, handleChangePrintdata, styles, disableFields } = this.props
    return (
      <div>
        <h2>Print Data</h2>
        <div style={{ paddingLeft: '40px', paddingBottom: '20px' }}>
          <h3> Custom Text Fields (Vertical) </h3>
                <TextField
                  floatingLabelText="Vertical Preview Text X"
                  floatingLabelStyle={styles.floatingLabelStyle}
                  floatingLabelFixed={true}
                  value={item.printData.portrait[0].textX}
                  type="number"
                  name={`portrait[0].textX`}
                  onChange={!disableFields ? handleChangePrintdata : ''}
                  style={styles.inputStyle}
                />
                <TextField
                  floatingLabelText="Vertical Preview Text Y"
                  floatingLabelStyle={styles.floatingLabelStyle}
                  floatingLabelFixed={true}
                  value={item.printData.portrait[0].textY}
                  type="number"
                  name={`portrait[0].textY`}
                  onChange={!disableFields ? handleChangePrintdata : ''}
                  style={styles.inputStyle}
                />
                <TextField
                  floatingLabelText="Vertical Preview Text Width"
                  floatingLabelStyle={styles.floatingLabelStyle}
                  floatingLabelFixed={true}
                  value={item.printData.portrait[0].textWidth}
                  type="number"
                  name={`portrait[0].textWidth`}
                  onChange={!disableFields ? handleChangePrintdata : ''}
                  style={styles.inputStyle}
                />
                <TextField
                  floatingLabelText="Vertical Preview Text Height"
                  floatingLabelStyle={styles.floatingLabelStyle}
                  floatingLabelFixed={true}
                  value={item.printData.portrait[0].textHeight}
                  type="number"
                  name={`portrait[0].textHeight`}
                  onChange={!disableFields ? handleChangePrintdata : ''}
                  style={styles.inputStyle}
                />
                <TextField
                  floatingLabelText="Vertical Preview Text Font Color"
                  floatingLabelStyle={styles.floatingLabelStyle}
                  floatingLabelFixed={true}
                  value={item.printData.portrait[0].fontColor}
                  name={`portrait[0].fontColor`}
                  onChange={!disableFields ? handleChangePrintdata : ''}
                  style={styles.inputStyle}
                />
          {item.printData.portrait.map((portrait, index) => {
            return (
              <div>
                {item.preview.numPhotos < 2
                  ? <h3 style={{ fontSize: '18px' }}>Vertical Print Settings</h3>
                  : <h3 style={{ fontSize: '18px' }}>Photo - {portrait.index}</h3>}
                <TextField
                  floatingLabelText="Bleed"
                  floatingLabelStyle={styles.floatingLabelStyle}
                  value={portrait.bleed}
                  name={`portrait[${index}].bleed`}
                  onChange={!disableFields ? handleChangePrintdata : ''}
                  floatingLabelFixed={true}
                  style={styles.inputStyle}
                />
                <TextField
                  floatingLabelText="Pdf Index"
                  floatingLabelStyle={styles.floatingLabelStyle}
                  value={portrait.pdfIndex}
                  name={`portrait[${index}].pdfIndex`}
                  onChange={!disableFields ? handleChangePrintdata : ''}
                  floatingLabelFixed={true}
                  style={styles.inputStyle}
                />
                <TextField
                  floatingLabelText="X"
                  floatingLabelStyle={styles.floatingLabelStyle}
                  value={portrait.x}
                  type="number"
                  name={`portrait[${index}].x`}
                  onChange={!disableFields ? handleChangePrintdata : ''}
                  floatingLabelFixed={true}
                  style={styles.inputStyle}
                />
                <TextField
                  floatingLabelText="Y"
                  floatingLabelStyle={styles.floatingLabelStyle}
                  value={portrait.y}
                  type="number"
                  name={`portrait[${index}].y`}
                  onChange={!disableFields ? handleChangePrintdata : ''}
                  floatingLabelFixed={true}
                  style={styles.inputStyle}
                />
                <TextField
                  floatingLabelText="Width"
                  floatingLabelStyle={styles.floatingLabelStyle}
                  value={portrait.width}
                  type="number"
                  name={`portrait[${index}].width`}
                  onChange={!disableFields ? handleChangePrintdata : ''}
                  floatingLabelFixed={true}
                  style={styles.inputStyle}
                />
                <TextField
                  floatingLabelText="Height"
                  floatingLabelStyle={styles.floatingLabelStyle}
                  value={portrait.height}
                  type="number"
                  name={`portrait[${index}].height`}
                  onChange={!disableFields ? handleChangePrintdata : ''}
                  floatingLabelFixed={true}
                  style={styles.inputStyle}
                />
                <TextField
                  floatingLabelText="Sku"
                  floatingLabelStyle={styles.floatingLabelStyle}
                  value={`${portrait.sku}`}
                  name={`portrait[${index}].sku`}
                  onChange={!disableFields ? handleChangePrintdata : ''}
                  floatingLabelFixed={true}
                  style={styles.inputStyle}
                />
              </div>)
          })}
          <br />
          <br />
          <br />
          {item.preview.numPhotos < 2 ?
            <div>
              {item.printData.landscape.map((landscape, index) => {
                return (
                  <div>
                    <h3 style={{ fontSize: '18px' }}>Horizontal Print Settings</h3>
                    <TextField
                      floatingLabelText="Bleed"
                      floatingLabelStyle={styles.floatingLabelStyle}
                      floatingLabelFixed={true}
                      value={landscape.bleed}
                      name={`landscape[${index}].bleed`}
                      onChange={!disableFields ? handleChangePrintdata : ''}
                      style={styles.inputStyle}
                    />
                    <TextField
                      floatingLabelText="Pdf Index"
                      floatingLabelStyle={styles.floatingLabelStyle}
                      value={landscape.pdfIndex}
                      name={`landscape[${index}].pdfIndex`}
                      onChange={!disableFields ? handleChangePrintdata : ''}
                      floatingLabelFixed={true}
                      style={styles.inputStyle}
                    />
                    <TextField
                      floatingLabelText="X"
                      floatingLabelStyle={styles.floatingLabelStyle}
                      value={landscape.x}
                      type="number"
                      name={`landscape[${index}].x`}
                      onChange={!disableFields ? handleChangePrintdata : ''}
                      floatingLabelFixed={true}
                      style={styles.inputStyle}
                    />
                    <TextField
                      floatingLabelText="Y"
                      floatingLabelStyle={styles.floatingLabelStyle}
                      value={landscape.y}
                      type="number"
                      name={`landscape[${index}].y`}
                      onChange={!disableFields ? handleChangePrintdata : ''}
                      floatingLabelFixed={true}
                      style={styles.inputStyle}
                    />
                    <TextField
                      floatingLabelText="Width"
                      floatingLabelStyle={styles.floatingLabelStyle}
                      value={landscape.width}
                      type="number"
                      name={`landscape[${index}].width`}
                      onChange={!disableFields ? handleChangePrintdata : ''}
                      floatingLabelFixed={true}
                      style={styles.inputStyle}
                    />
                    <TextField
                      floatingLabelText="Height"
                      floatingLabelStyle={styles.floatingLabelStyle}
                      value={landscape.height}
                      type="number"
                      name={`landscape[${index}].height`}
                      onChange={!disableFields ? handleChangePrintdata : ''}
                      floatingLabelFixed={true}
                      style={styles.inputStyle}
                    />
                    <TextField
                      floatingLabelText="Sku"
                      floatingLabelStyle={styles.floatingLabelStyle}
                      value={landscape.sku}
                      name={`landscape[${index}].sku`}
                      onChange={!disableFields ? handleChangePrintdata : ''}
                      floatingLabelFixed={true}
                      style={styles.inputStyle}
                    />
                  </div>)
              })}
              <br />
            </div>
            : null}
        </div>
      </div>
    )
  }
}

export default PrintData


// WEBPACK FOOTER //
// ./src/components/items/Common/PrintData.js